<template>
    <div class="airanking">
        <a-page-header
            style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
            :breadcrumb="{ props: { routes } }"
        />

        <div class="airanking-detail">
            <a-card title="万词快排分析">
                <a-row>
                    <a-col :span="6" style="margin-top:50px;padding-left:50px">
                        <p>关键词数：<span data-v-3d84116b="" class="red">0 </span> 个</p>
                        <p>查询日期：2020-12-09</p>
                        <p>推广地址：<a href="">www.szlvnuo.com</a></p>
                    </a-col>
                    <a-col :span="9">
                        <div id="chart" style="width:100%;height:250px"></div> 
                    </a-col>
                    <a-col :span="9">
                        
                    </a-col>
                </a-row>
            </a-card>
            
            <a-card title="排名信息" class="bottom-table" style="margin-top:24px">
                <div class="search  push-search">
                    <a-select default-value="all" style="width: 200px" >
                        <a-select-option value="all">
                            百度PC
                        </a-select-option>
                        <a-select-option value="system">
                            百度移动
                        </a-select-option>
                        <a-select-option value="jack">
                            搜狗PC
                        </a-select-option>
                         <a-select-option value="sgwap">
                            搜狗移动
                        </a-select-option>
                         <a-select-option value="360pc">
                            360PC
                        </a-select-option>
                         <a-select-option value="360wap">
                            360移动
                        </a-select-option>
                    </a-select>
                </div>
                <div>
                    <a-table
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    :data-source="data"
                    >
                    </a-table>
                </div>
            </a-card>
        </div>


    </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import router from "@/router/index"
let echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/line')
// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/legendScroll')//图例滚动
const columns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: '关键词',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: '位置',
    dataIndex: 'address',
    key: 'address',
  }
];
const data = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
    tags: '钢化玻璃',
    url:'http://shop.zzzs2010.cn/14476/index.html?nestshop|360',
    ipaddress:'未读',
    money:'26',
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 42,
    address: 'London No. 1 Lake Park',
    tags: '阳台玻璃',
    url:'http://shop.zzzs2010.cn/14476/index.html?nestshop|360',
    ipaddress:'已读',
    money:'3.2',
  },
];

export default {
    data(){
        return{
            data,
            locale,
            columns,
            pagination: {},
            loading: false,
            routes: [
                {breadcrumbName: '首页'},
                {breadcrumbName: '排名查询'},
                {breadcrumbName: '自然排名'},
            ],
        }
    },
    mounted(){
        this.drawLine();
    },
    methods:{
        onChange(date, dateString) {
            console.log(date, dateString);
        },
        handleTableChange(pagination, filters, sorter) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                results: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },

        drawLine(){
            var chart = this.$echarts.init(document.getElementById("chart"))
            chart.setOption({
                title: {
                text: 'PC搜索',
                textStyle: {
                    fontWeight: 'normal',
                }
                },
                color:'#709af3',
                tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'line' 
                },
                backgroundColor:'#fff',	
                textStyle: {
                    color: "#666" //设置文字颜色
                },
                extraCssText: 'box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);'
                },
                grid: {
                left: '5%',
                right: '4%',
                bottom: '3%',
                containLabel: true
                },
                xAxis: {
                type: 'category',
                boundaryGap: false,
                data: ['00时', '02时', '04时', '06时', '08时', '10时', ]
                },
                
                yAxis: {
                type: 'value'
                },
                series: [{
                name: '数量',
                data: [20, 32, 61, 34, 12, 30, 10,0,0,0,0,0],
                type: 'line',
                areaStyle: {
                    color:'#709af3',
                    opacity:0.4
                }
                }]
            });
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/ranking/airanking.vue